import axios from "axios";
import Vue from "vue";
import authService from "../modules/authService";
import i18n from "@/plugins/i18n";
import Router from "@/router";

const headers = {
  "content-type": "application/json",
  Accept: "application/json",
  "Accept-Language": "en"
};

const API_GATEWAY = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_GATEWAY,
  headers
});

API_GATEWAY.interceptors.request.use(
  config => {
    config.headers["Accept-Language"] = i18n.locale;
    const token = authService.getAccessToken();
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

API_GATEWAY.interceptors.response.use(
  response => {
    return response;
  },
  async function(error) {
    if (error.message === "Network Error") {
      networkIssue();
    }
    // if (error.response.data.error === "Unauthorized") {
    else if (error.response.status === 401) {
      const refreshToken = authService.getRefreshToken();
      if (refreshToken) {
        authService
          .getNewRefreshToken({ refreshToken })
          .then(response => {
            localStorage.setItem(
              "access_token",
              response.data.data.access_token
            );
            localStorage.setItem(
              "refresh_token",
              response.data.data.refresh_token
            );
            return API_GATEWAY.request(error.config);
          })
          .catch(() => {
            checkToChangeRoute(error);
          });
      } else {
        checkToChangeRoute(error);
      }
    } else if (error && error.response.config.method !== "get") {
      Vue.$toast.clear();
      if (error.response.data.errors) {
        Object.values(error.response.data.errors).forEach(value => {
          Vue.$toast.error(value[0]);
        });
      } else if (
        (!error.response.data.errors ||
          error.response.data.errors.length === 0) &&
        error.response.data.message
      ) {
        Vue.$toast.error(error.response.data.message);
      }
    }
    return Promise.reject(error.response);
  }
);

const networkIssue = () => {
  // Vue.$toast.error("Network CORS Issue");
  checkException();
};

let errorMessageContent = "";

const checkToChangeRoute = error => {
  // to prevent iterative errors
  if (error.response.data.message !== errorMessageContent) {
    errorMessageContent = error.response.data.message;
    Vue.$toast.error(error.response.data.message);
    setTimeout(() => {
      errorMessageContent = "";
    }, 1000);
  }
  // check the exception states if it's not defined there, it will be routed to the login page.
  checkException();
};

const checkException = () => {
  if (!exception()) {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    if (Router.history.current.name !== "loginForm") {
      Router.replace({ name: "loginForm" });
    }
  }
};

const exception = () => Router.history.current.name === "forgetPassword";

export default API_GATEWAY;
